import { TextLink } from '@lastbrand/web-ui/text-link'
import { css } from '@lastbrand/web-ui-styled-system/css'
import React, { ReactNode } from 'react'

import { useZipCodeEditModal } from '@src/quince-site-common/src/hooks/zipcode'

import type { SystemStyleObject } from '@lastbrand/web-ui-styled-system/types'

// Single underline from TextLink's own text-decoration; line-height inherits the wrapper's body-14.
const zipLinkCss = css.raw({
  display: 'inline',
  color: 'inherit',
})

export interface ZipCodeButtonDSProps {
  children: ReactNode
  /** Extra DS style object merged onto the base underlined zip-link styling. */
  cssOverride?: SystemStyleObject
}

/**
 * DS twin of the legacy ZipCodeButton. Renders a web-ui TextLink styled as the
 * underlined zip trigger; clicking opens the zip-code edit modal via the shared
 * useZipCodeEditModal hook (verbatim, not reimplemented).
 */
export function ZipCodeButtonDS({ children, cssOverride }: ZipCodeButtonDSProps) {
  const { openZipcodeModal } = useZipCodeEditModal()

  return (
    <TextLink
      type="button"
      css={{ ...zipLinkCss, ...(cssOverride ?? {}) }}
      onClick={() => {
        openZipcodeModal(true)
      }}
    >
      {children}
    </TextLink>
  )
}

export default ZipCodeButtonDS
